<template>
  <section class="content">
    <box >
      <div slot="body">
        <div class="row">
          <div class="col-md-6">
              <h4>Nome</h4>
              <input v-model="servico.nome" type="text" class="form-control">
              <label v-if="nome===''">*Campo Obrigatório</label>
          </div>
          <div class="col-md-6">
            <h4>Descrição</h4>
            <textarea v-model="servico.descricao" rows="1" cols="12" class="form-control"></textarea>
          </div>
      </div>
      <div class="row">
          <div class="col-md-3">
              <h4>Tempo (min)</h4>
              <input v-model="servico.tempo" type="text" class="form-control">
          </div>
          <div class="col-md-3">
              <h4>Categoria</h4>
              <select class="form-control" v-model="servico.categorias_id">
                <option v-for="c in categories" v-bind:value="c.id">{{c.descricao}}</option>
              </select>
          </div>
          <div class="col-md-2">
              <h4>Preço</h4>
              <money v-model="servico.preco" v-bind="money" class="form-control"></money>
          </div>

          <div class="col-md-4"><br>
              <div style="text-align:left">
                <label class="v-label">Imagem</label><br>
                <input type="file" :multiple="false" ref="fileInput" id="file-input">
              </div>
          </div>
          
      </div>
      <br>
      <div class="row">
        <div class="col-md-1">
          <h4>Ativo</h4>
            <toggle-button 
              v-model="servico.ativo"
              :color="color" 
              :sync="true" />
        </div>
      </div>
      <br><br>
      <router-link class="pageLink" to="/servicos">
              <button class="btn btn-danger" >Cancelar</button>
      </router-link>
      <button class="btn btn-success" @click="gravar" v-show="habilitaGravar && !loading" >
        <i class="fa fa-check">  Gravar</i>
      </button>
      <button v-show="loading" class="btn btn-success"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>
      </div>
    </box>
  </section>
</template>

<script>
import resource from './resource';
import Box from '../Box'
import {Money} from 'v-money'
import { resourceCategorias } from '../ServicoCategorias/resource';
import s3 from '../../../services/s3'

export default {
  name: 'Novo Serviço',
  // directives: {money: VMoney},
  components: {
    'box': Box,
    Money
  },
  data: () => ({
    dialog: false,
    idEditar: false,
    categories: [],
    servico: {
      nome: '',
      descricao: '',
      tempo: 0,
      preco: 0,
      ativo: false,
      categorias_id: 0
    },
    loading: false,
    dialogErro: false,
    erro: '',
    alteracao: false
  }),
  computed: {
    habilitaGravar: function () {
      return this.servico.nome && this.servico.descricao && this.servico.tempo
    }
  },
  created() {
    this.getCategorias()
    if(this.$route.params.id) {
      console.log('alterando');
      this.alteracao = true
      this.idEditar = this.$route.params.id
      this.getServico(this.idEditar)
    }
  },
  methods: {
    gravar () {
      this.loading = true
      const files = document.getElementById('file-input').files;
      const file = files[0];

      if(file != null) {
        s3.getSignedRequest(file).then(res => {
          this.servico.imagem = res.url
          this.submit();
        }).catch(err => {
          alert('Erro ao salvar imagem');
        })
      } else {
        if(this.alteracao) {
          this.submit();
        } else {
          alert('É necessário selecionar uma imagem.');
          this.loading = false
        }
      }
          // this.imagem = 'https://s3-sa-east-1.amazonaws.com/baita-batata/baitabatata-logo.jpg'
          // this.gravarProduto()
    },
    async submit() {
      this.loading = true;
      let serv = await _.pickBy(this.servico, function(a){ return a !== null });
      if(this.idEditar) {
        resource.atualizaServico(serv, this.idEditar).then((res) => {
          this.idEditar = null;
          this.idEditar = false;
          this.$router.go(-1);
        }).catch(responseError => {
          this.dialogErro = true
          this.erro = responseError.response.data.message
          this.loading =false
        });
      } else {
        this.servico.empresa = localStorage.getItem('FB_ID');
        resource.gravaServico(this.servico).then((res) => {
          this.idEditar = false;
          this.$router.go(-1);
        }).catch(responseError => {
          this.dialogErro = true
          this.erro = responseError.response.data.message
          this.loading =false
        })
      }
    },
    getServico() {
      resource.getServico(this.idEditar).then((res) => {
        this.servico = res.data
      });
    },
    getCategorias() {
      resourceCategorias.getListaCategorias().then((res) => {
        this.categories = res.data
      }).catch(err => {
        console.log('erro ao buscar categorias ', err);
      }) 
    },
    close() {
      this.dialog = false; 
      this.$emit('close');
    }
  }
};
</script>


// WEBPACK FOOTER //
// novoServico.vue?321bdc45